// Ported from the Ember UI (`app/utils/billing/feature-groups.ts`).
// These are static feature groups for now. In the future they will be dynamic
// and loaded from the back end.
export const FeatureGroup = {
  FG1: 'FG-1',
  FG2: 'FG-2',
  FG3: 'FG-3',
  FG4: 'FG-4',
  FG5: 'FG-5',
  FG6: 'FG-6',
  FG7: 'FG-7',
  FG8: 'FG-8',
  FG9: 'FG-9',
  FG10: 'FG-10',
} as const;
export type FeatureGroup = (typeof FeatureGroup)[keyof typeof FeatureGroup];

interface FeatureGroupConfig {
  productJourneys?: Record<string, never>;
  productPipelines?: Record<string, never>;
  featureCollections?: Record<string, never>;
  featureMessaging?: Record<string, never>;
  featureWarehouseSync?: Record<string, never>;
  featureCSM?: Record<string, never>;
  featureCSMOnboarding?: Record<string, never>;
  featureCDPPremiumIntegrations?: Record<string, never>;
  featureEnterpriseTS?: Record<string, never>;
  featureSupportTierEmail?: Record<string, never>;
  featureSupportTierChat?: Record<string, never>;
  featureSupportTierCommunity?: Record<string, never>;
  featurePremiumTrial?: Record<string, never>;
  featureSensitiveAttributes?: Record<string, never>;
  featureWorkspaces?: {
    limit: number;
  };
  featureObjectTypes?: {
    limit: number;
  };
  featureMaxObjectJourneys?: {
    limit: number;
  };
}

export const featureGroups = Object.freeze<Record<FeatureGroup, FeatureGroupConfig>>({
  // AKA Essentials
  [FeatureGroup.FG1]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureWorkspaces: {
      limit: 2,
    },
    featureObjectTypes: {
      limit: 2,
    },
    featureMaxObjectJourneys: {
      limit: 500,
    },
  },
  // AKA Premium
  [FeatureGroup.FG2]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureCollections: {},
    featureWarehouseSync: {},
    featureCSMOnboarding: {},
    featureCDPPremiumIntegrations: {},
    featureSupportTierChat: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureSensitiveAttributes: {},
    featureWorkspaces: {
      limit: 0,
    },
    featureObjectTypes: {
      limit: 10,
    },
    featureMaxObjectJourneys: {
      limit: 5_000,
    },
  },
  // AKA Enterprise
  [FeatureGroup.FG3]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureCollections: {},
    featureWarehouseSync: {},
    featureCSM: {},
    featureEnterpriseTS: {},
    featureCSMOnboarding: {},
    featureCDPPremiumIntegrations: {},
    featureSupportTierChat: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureSensitiveAttributes: {},
    featureWorkspaces: {
      limit: 0,
    },
    featureObjectTypes: {
      limit: 10,
    },
    featureMaxObjectJourneys: {
      limit: 5_000,
    },
  },
  // AKA Startup Basic
  [FeatureGroup.FG4]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureWorkspaces: {
      limit: 0,
    },
    featureObjectTypes: {
      limit: 2,
    },
    featureMaxObjectJourneys: {
      limit: 500,
    },
  },
  // AKA Startup+
  [FeatureGroup.FG5]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureCollections: {},
    featureWarehouseSync: {},
    featureEnterpriseTS: {},
    featureCDPPremiumIntegrations: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureSensitiveAttributes: {},
    featureWorkspaces: {
      limit: 0,
    },
    featureObjectTypes: {
      limit: 10,
    },
    featureMaxObjectJourneys: {
      limit: 5_000,
    },
  },
  // AKA CDP Only
  [FeatureGroup.FG6]: {
    productPipelines: {},
    featureSupportTierCommunity: {},
    featureWorkspaces: {
      limit: 0,
    },
  },
  // AKA Basic
  [FeatureGroup.FG7]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureCollections: {},
    featureWarehouseSync: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureWorkspaces: {
      limit: 0,
    },
    featureObjectTypes: {
      limit: 2,
    },
    featureMaxObjectJourneys: {
      limit: 500,
    },
  },
  // AKA Free trial
  [FeatureGroup.FG8]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureWorkspaces: {
      limit: 2,
    },
    featureObjectTypes: {
      limit: 2,
    },
  },
  // AKA Startup Essentials
  [FeatureGroup.FG9]: {
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureSupportTierCommunity: {},
    featureWorkspaces: {
      limit: 0,
    },
    featureObjectTypes: {
      limit: 2,
    },
    featureMaxObjectJourneys: {
      limit: 500,
    },
  },
  // AKA Premium Trial
  [FeatureGroup.FG10]: {
    featurePremiumTrial: {},
    productJourneys: {},
    productPipelines: {},
    featureMessaging: {},
    featureCollections: {},
    featureWarehouseSync: {},
    featureCSMOnboarding: {},
    featureCDPPremiumIntegrations: {},
    featureSupportTierChat: {},
    featureSupportTierEmail: {},
    featureSupportTierCommunity: {},
    featureSensitiveAttributes: {},
    featureWorkspaces: {
      limit: 0,
    },
    featureObjectTypes: {
      limit: 10,
    },
    featureMaxObjectJourneys: {
      limit: 5000,
    },
  },
} as const);
